import { Component } from '@angular/core';
import { BuyBtnComponent } from 'gung-standard';

@Component({
    selector: 'cult-buy-btn',
    templateUrl: './cult-buy-btn.component.html',
    styleUrls: ['./cult-buy-btn.component.scss'],
    standalone: false
})
export class CultBuyBtnComponent extends BuyBtnComponent {
  setValues(): void {
    this.minimumOrderQuantity = this.productInputQuantityConfigService.getMinimumOrderQuantity(this.id, this.product);

    this.allowManualQtyInputOutsideStepSizes =
      this.productInputQuantityConfigService.getAllowManualQtyInputOutsideStepSizes(this.id, this.product);

    this.stepAmount = this.productInputQuantityConfigService.getStepAmount(this.id, this.product);

    this.recomendedInitOrderQuantity = this.productInputQuantityConfigService.getRecomendedInitOrderQuantity(
      this.id,
      this.product
    );
  }
}
